export const textToHtml = text => {
  if (typeof text !== 'string') {
    new Error('Text is not a string')
  }

  const parser = new DOMParser()

  return parser.parseFromString(text, 'text/html')
}

const defaultDecimal = 2

export const toDecimalString = (value, decimal = defaultDecimal) =>
  Number.parseFloat(value).toFixed(decimal)

export const toDecimalFloat = (value, decimal = defaultDecimal) => {
  const floatValue = Number.parseFloat(value)
  const decimalsValue = 10 ** decimal
  return Math.round(floatValue * decimalsValue) / decimalsValue
}

export const toCurrency = (value = 0.0) => {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

export const formatInputCurrency = value => {
  let cleanValue = value.replace(/\D/g, '')

  if (cleanValue.length === 1) {
    cleanValue = `0${cleanValue}`
  }

  const integerValue = parseInt(cleanValue.slice(0, -2) || '0', 10)
  const decimalValue = cleanValue.slice(-2)

  const formattedIntegerValue = integerValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  return `${formattedIntegerValue},${decimalValue}`
}

const formatToOutput = (str, output) =>
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map(x => x[output]())

export const toSnakeCase = (str, output = 'toLowerCase') =>
  formatToOutput(str, output).join('_')

export const toKebabCase = (str, output = 'toLowerCase') =>
  formatToOutput(str, output).join('-')

export const toKommaString = num => {
  return num.toString().replace('.', ',')
}

export const toBoolean = value => {
  return value === 'true' || value === true
}

export const toNumber = value => {
  return value ? parseInt(value) : 0
}
